export default __webpack_public_path__ + "static/media/bitcoin-icon.e200daf9.png";